import { SettingsApiService } from '../../common/services/settings.api.service';
import { SettingsModel } from '../../common/models/settings.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: {},
  },
  getters: {
    getAll: state => state.items,
    getPricelistsAllowed: state => state.items.priceListsPreference && state.items.priceListsPreference === '1',
    getBlogCommentsAllowed: state => state.items.articleCommentsAllowed && state.items.articleCommentsAllowed === '1',
    getAfterPrintOrderState: state => Number(state.items.setOrderStateAfterOrderPrint),
    getChangeOrderStateAfterOrderPrintIds: state => state.items.changeOrderStateAfterOrderPrintIds,
    getTimezone: state => state.items.timezone,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAll({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return SettingsApiService.getAll()
        .then(response => {
          const parsedSettings = response.getItems().reduce((acc, settingsRecord) => {
            acc[settingsRecord.key] = settingsRecord.value;
            return acc;
          }, {});

          commit('SET_ITEMS', new SettingsModel(parsedSettings));
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
